import jwtDecode from "jwt-decode";
import { AppStorage } from "@service/api-client/http/helpers/AppStorage";
import { utcToZonedTime } from "@service/api-client/utils/date-time.converter";
import { customerAuthTokenName } from "../base-api/base-api.constant.js";
const removeCustomerExpiredAuthToken = () => {
  const storedCustomer = AppStorage.get(customerAuthTokenName);
  const { token } = storedCustomer || {};
  if (token) {
    try {
      const { exp } = jwtDecode(token);
      const clientZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const currentTime = +utcToZonedTime(/* @__PURE__ */ new Date(), clientZone, { timestamp: true });
      const diff = exp * 1e3 - currentTime;
      if (diff < 0) {
        AppStorage.remove(customerAuthTokenName);
      }
    } catch (error) {
      console.error(`Failed to remove expired JWT token: ${error.message}`);
    }
  }
};
export {
  removeCustomerExpiredAuthToken
};
